import React, { useState } from "react";
import CustomerSidebar from "../component/CustomerSidebar";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";

const CustomerMyAccount = () => {
  return (
    <>
    <VisitorNavbar/>
    <div>
      <section className="mb-5">
        <div className="container-fluid">
          <div className="row my-3 g-2 justify-content-center">
            <div className="col-md-2">
                <CustomerSidebar/>
            </div>
            <div className="col-md-10">
              <div className="reviewcls">
                <h4 className="review-form-heading text-start">My Account</h4>
                <p className="payttl text-start">
                  Update your account information below.
                </p>
                <hr />
                <form className="contact-form text-start">
                  <div className="row g-2">
                    <div className="col-md-6">
                      <label htmlFor="firstName" className="form-label">
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        className="form-control"
                        placeholder="Enter your first name"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="lastName" className="form-label">
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        className="form-control"
                        placeholder="Enter your last name"
                        required
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="email" className="form-label">
                        Email Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        placeholder="Enter your email address"
                        required
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="address" className="form-label">
                        Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="address"
                        className="form-control"
                        placeholder="Enter your address"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="city" className="form-label">
                        City <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="city"
                        className="form-control"
                        placeholder="Enter your city"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="state" className="form-label">
                        State <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="state"
                        className="form-control"
                        placeholder="Enter your state"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="country" className="form-label">
                        Country <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="country"
                        className="form-control"
                        placeholder="Enter your country"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="pincode" className="form-label">
                        Pincode <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="pincode"
                        className="form-control"
                        placeholder="Enter your pincode"
                        required
                      />
                    </div>
                  </div>
                  <div className="mt-3 text-end">
                    <button type="submit" className="btn submitbtnn w-25">
                      Update Information
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <Footer/>
    </>
  );
};

export default CustomerMyAccount;
